<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
        </ol>
      </div>
    </header>
    <div id="calendar" class="row">
      <div class="col-md-12">
        <section class="panel">
          <header class="panel-heading">
            <div class="panel-actions">
              <a href="#" class="panel-action panel-action-toggle" data-panel-toggle=""></a>
            </div>
            <h2 class="panel-title">排班</h2>
          </header>
          <div class="panel-body">
            <a href="#" @click.prevent="toCostPage" v-if="id==null" class="btn-upload btn" style="background-color:red; border-color:red; color:#FFF;">設定日保/月保</a>
            <a href="javascript:;" v-if="id!=null" class="btn btn-schedule" @click="popupOpen()">新增排班</a>
            <div :id="this.uid" class="monthly" ref="monthly"></div>
          </div>
        </section>
      </div>
    </div>
    <div id="multiple" class="calendar-popup dialog dialog-lg zoom-anim-dialog mfp-hide">
      <h3>多筆排班【{{selectDate}}】</h3>
      <div class="popup-content">
        <table>
          <tr v-for="(item, index) in calendarTimeList" :key="index">
            <td tkey="calendarTime" class="name">{{item}}</td>
            <td tkey="calendarName"></td>
          </tr>
        </table>
        <br>
        <table>
          <tr v-for="(item, index) in dateScheduleList" :key="index">
            <td v-if="item.workstudyType !== 1 && isCheckLock" width="32%" align="center">
              <span style="color: red;">本月份排班已鎖定，不可刪除</span>
            </td>
            <td v-else-if="item.isCheck" width="32%" align="center">
              <span style="color: red;">本筆排班已審核，不可刪除</span>
            </td>
            <td v-else width="32%" align="center">
              <a href="#" @click.prevent="delSchedule(item.scheduleId)" class="btn-danger btn">刪除此筆排班</a>
              <a href="#" @click.prevent="delScheduleRange(item.rangeId, item.scheduleId)" class="btn-danger btn">刪除此筆與後續排班</a>
            </td>
            <td width="68%">{{item.workstudyType == 1 ? "[生活]" : item.workstudyType == 2 ? "[勞雇]" : ""}}({{item.studentId}}){{item.studentName}} - {{item.workDateRange}} | {{item.workTimeRange}} （{{item.workWeekday}}）</td>
          </tr>
        </table>
      </div>
      <!-- <div class="btn-block text-center">
        <button class='btn btn-default btnPopupClose'>取消</button>
        <button class='btn btn-primary btnPopupClose'>確定</button>
      </div> -->
    </div>
    <div class="bootbox modal fade in" tabindex="-1" role="dialog" style="display: block;" v-show="isBootbox">
      <div class="modal-dialog modal-lg" >
        <div id="schedule" class="modal-content calendar-popup  ">
          <h3>新增排班</h3>
          <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -33px; margin-right: 16px;" @click="popupClose()">×</button>
          <div class="modal-body">
            <div class="bootbox-body" style="min-height: 310px;">
              <div class="row col-sm-offset-1 col-sm-10">
                <div class="row">
                  <label class="col-sm-3 control-label"><i class="fa fa-clock-o"></i> 時間</label>
                  <div class="col-sm-9">
                    <div class="row form-group ">
                      <div class="col-sm-5">
                        <!-- :disabled-dates="beginState.disabledDates" -->
                        <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="schedule.startDate"  input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}"
                                    :openDate="new Date(`${setYear}-${setMonth}-1`)"/>
                      </div>
                      <div class="col-sm-5">
                        <!-- :disabled-dates="beginState.disabledDates" -->
                        <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="schedule.endDate"  input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}"
                                    :openDate="new Date(`${setYear}-${setMonth}-1`)"/>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-sm-3">
                        <select class="form-control mb-md" v-model="schedule.startHour" @change="setCheckValue">
                          <option v-for="item in getNumbers(6, 22)" :key="item" :value="item">{{item | twoDigits}}</option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        <select class="form-control mb-md" v-model="schedule.startMin" @change="setCheckValue">
                          <option :value="0">00</option>
                          <option :value="30">30</option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        <select class="form-control mb-md" v-model="schedule.endHour" @change="setCheckValue">
                          <option v-for="item in getNumbers(6, 22)" :key="item" :value="item">{{item | twoDigits}}</option>
                        </select><br>
                      </div>
                      <div class="col-sm-3">
                        <select class="form-control mb-md" v-model="schedule.endMin" @change="setCheckValue">
                          <option :value="0">00</option>
                          <option :value="30">30</option>
                        </select>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-sm-12">
                        <div class="checkbox-custom chekbox-primary">
                          <input id="isDeductLunch" type="checkbox" :disabled="!((schedule.startHour<12||(schedule.startHour==12&&schedule.startMin==0))&&schedule.endHour>=13)" v-model="schedule.isDeductLunch">
                          <label for="isDeductLunch" style="font-size: 14px; padding: 6px;">扣除午休時數(1小時)</label>
                        </div>
                        <div class="checkbox-custom chekbox-primary">
                          <input id="isDeductDinner" type="checkbox" :disabled="!((schedule.startHour<17||(schedule.startHour==17&&schedule.startMin==0))&&schedule.endHour>=18)" v-model="schedule.isDeductDinner">
                          <label for="isDeductDinner" style="font-size: 14px; padding: 6px;">扣除晚餐時數(1小時)</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 control-label"><i class="fa fa-calendar-o"></i> 重複日期：</label>
                  <div class="col-sm-9">
                    <div class="input-checkbox">
                      <input id="week0" type="checkbox" name="week" :value="0" v-model="schedule.weekList">
                      <label for="week0">日</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week1" type="checkbox" name="week" :value="1" v-model="schedule.weekList">
                      <label for="week1">一</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week2" type="checkbox" name="week" :value="2" v-model="schedule.weekList">
                      <label for="week2">二</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week3" type="checkbox" name="week" :value="3" v-model="schedule.weekList">
                      <label for="week3">三</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week4" type="checkbox" name="week" :value="4" v-model="schedule.weekList">
                      <label for="week4">四</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week5" type="checkbox" name="week" :value="5" v-model="schedule.weekList">
                      <label for="week5">五</label>
                    </div>
                    <div class="input-checkbox">
                      <input id="week6" type="checkbox" name="week" :value="6" v-model="schedule.weekList">
                      <label for="week6">六</label>
                    </div>　
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row form-group" style="height:50px;">
            <div class="col-sm-12 col-md-offset-4 col-md-4 text-center">
                <div class="col-xs-offset-1 col-xs-4">
                    <button @click.prevent="popupClose" class='btn btnPopupClose btn-default' style="width:100%;">取消</button>
                </div>
                <div class="col-xs-offset-1 col-xs-4">
                    <button @click.prevent="scheduleSubmit" class='btn btnPopupClose btn-primary' style="width:100%;">儲存</button>
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  data() {
    return {
      schedule: {
        startDate: "",
        endDate: "",
        startHour: 6,
        startMin: 0,
        endHour: 6,
        endMin: 0,
        isDeductLunch: false,
        isDeductDinner: false,
        weekList: [],
        lockYearMonth: "",
      },
      selectDate: "",
      dateScheduleList: [],
      calendarTimeList: [
        "06:00~06:30",
        "06:30~07:00",
        "07:00~07:30",
        "07:30~08:00",
        "08:00~08:30",
        "08:30~09:00",
        "09:00~09:30",
        "09:30~10:00",
        "10:00~10:30",
        "10:30~11:00",
        "11:00~11:30",
        "11:30~12:00",
        "12:00~12:30",
        "12:30~13:00",
        "13:00~13:30",
        "13:30~14:00",
        "14:00~14:30",
        "14:30~15:00",
        "15:00~15:30",
        "15:30~16:00",
        "16:00~16:30",
        "16:30~17:00",
        "17:00~17:30",
        "17:30~18:00",
        "18:00~18:30",
        "18:30~19:00",
        "19:00~19:30",
        "19:30~20:00",
        "20:00~20:30",
        "20:30~21:00",
        "21:00~21:30",
        "21:30~22:00",
        "22:00~22:30",
      ],
      beginState: {
        disabledDates: {
          to: null,
        },
      },
      isBootbox: false,
      isCheckLock: false,
      setYear: "",
      setMonth: "",
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },

  },
  mounted() {
    this.beginState.disabledDates.to = this.nowDate();
    let now = this.nowDate();
    this.lockYearMonth = "" + now.getFullYear() + "/" + (now.getMonth() + 1);
    // if (now.getDay > 26) {
    //   let month = now.getMonth() + 2;
    //   if (month > 12) this.lockYearMonth = "" + (now.getFullYear() + 1) + "/1";
    //   else this.lockYearMonth = "" + now.getFullYear() + "/" + month;
    // }

    this.calendar();
    $(".popup-with-zoom-anim").magnificPopup({
      type: "inline",
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
  methods: {
    calendar() {
      let vm = this;
      let monthly = this.$refs.monthly;
      let url = "schedule-json";
      if (this.id) url = "schedule-json-single/" + this.id;
      $(monthly).monthly({
        mode: "event",
        jsonUrl: "/api/workstudy/" + url,
        dataType: "json",
        weekStart: 0,
        dayNames: ["日", "一", "二", "三", "四", "五", "六"],
      });
      this.setYear = $(monthly).data("setYear")
      this.setMonth = $(monthly).data("setMonth")

      $(monthly).on("click touchstart", ".btn-popup", function (e) {
        e.preventDefault();
        if ($(this).attr("href") == "#multiple") {
          setTimeout(() => {
            vm.loadDelList();
          }, 100);
          $.magnificPopup.open(
            {
              items: { src: $(this).attr("href") },
              type: "inline",
              fixedContentPos: false,
              fixedBgPos: true,
              overflowY: "auto",
              closeBtnInside: true,
              preloader: false,
              midClick: true,
              removalDelay: 300,
              mainClass: "my-mfp-zoom-in",
            },
            0
          );
        } else {
          if ($(window).width() <= 768) {
            var urlName = $(this).text();
            var urlLeave = $(this)
              .next(".btn-block")
              .find("[tkey='calendarLeave']")
              .attr("href");
            var urlRecord = $(this)
              .next(".btn-block")
              .find("[tkey='calendarRecord']")
              .attr("href");
            $.magnificPopup.open(
              {
                items: { src: $(this).attr("href") },
                type: "inline",
                fixedContentPos: false,
                fixedBgPos: true,
                overflowY: "auto",
                closeBtnInside: true,
                preloader: false,
                midClick: true,
                removalDelay: 300,
                mainClass: "my-mfp-zoom-in",
              },
              0
            );
            $("#single [tkey='singleLeave']").attr("href", urlLeave);
            $("#single [tkey='singleRecord']").attr("href", urlRecord);
            if(!urlLeave){
              $("#single [tkey='singleLeave']").attr("disabled", "disabled");
              $("#single [tkey='singleLeave']").attr("href", "javascript:;");
            }
            if(!urlRecord){
              $("#single [tkey='singleRecord']").attr("disabled", "disabled");
              $("#single [tkey='singleRecord']").attr("href", "javascript:;");
            }
            $("#single [tkey='singleTitle']").text(urlName);
          }
        }
        $(".calendar-popup").on("click", ".btnPopupClose", function () {
          $.magnificPopup.close();
        });
      });
    },
    scheduleSubmit() {
      if (this.checkSchedule() == false) return;
      this.$http
        .post("/api/workstudy/create-schedule/" + this.id, this.schedule)
        .then((a) => {
          if (a.body.status) {
            alert("儲存成功");
            this.isBootbox = false;
            $(".monthly-reload").click();
            this.schedule.startDate = "";
            this.schedule.endDate = "";
            this.schedule.startHour = 6;
            this.schedule.startMin = 0;
            this.schedule.endHour = 6;
            this.schedule.endMin = 0;
            this.schedule.isDeductLunch = false;
            this.schedule.isDeductDinner = false;
            this.schedule.weekList = [];
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    checkSchedule() {
      let msg = "";
      if (this.schedule.startDate == "" || this.schedule.endDate == "")
        msg += "『時間』 尚未填寫\r\n";
      if (msg != "") {
        alert(msg);
        return false;
      }
      let sd = new Date(this.schedule.startDate),
        ed = new Date(this.schedule.endDate);
      if (sd > ed) {
        alert("『開始日期』請晚於『結束日期』");
        return false;
      }
      if (
        this.schedule.startHour > this.schedule.endHour ||
        (this.schedule.startHour == this.schedule.endHour &&
          this.schedule.startMin > this.schedule.endMin)
      ) {
        alert("『開始時間』請晚於『結束時間』");
        return false;
      }
      if (
        this.schedule.startHour == this.schedule.endHour &&
        this.schedule.startMin == this.schedule.endMin
      ) {
        alert("『開始時間』不可與『結束時間』相同");
        return false;
      }
      return true;
    },
    popupOpen() {
      this.setYear = $(this.$refs.monthly).data("setYear")
      this.setMonth = $(this.$refs.monthly).data("setMonth")
      this.isBootbox = true;
    },
    popupClose() {
      this.isBootbox = false;
    },
    toCostPage() {
      let year = $(this.$refs.monthly).data("setYear");
      let month = $(this.$refs.monthly).data("setMonth");
      this.$router.push("/workstudy/cost/" + year + "/" + month);
    },
    loadDelList() {
      this.selectDate = $(this.$refs.monthly).data("setDate");
      let selectDateArray = this.selectDate.split("-");
      // let selectYear = parseInt(selectDateArray[0]);
      // let selectMonth = parseInt(selectDateArray[1]);
      let lockYMArray = this.lockYearMonth.split("/");
      // let lockYear = parseInt(lockYMArray[0]);
      // let lockMonth = parseInt(lockYMArray[1]);
      // if (
      //   selectYear < lockYear ||
      //   (selectYear == lockYear && selectMonth <= lockMonth)
      // )
      this.$http
        .get("/api/workstudy/date-schedule-list", {
          params: { date: this.selectDate },
        })
        .then((a) => {
          this.dateScheduleList = a.body.item1;
          this.isCheckLock = a.body.item2;
        });
    },
    delSchedule(id) {
      if (!confirm("您的動作將會刪除此筆排班資料。\n請問是否確認要刪除？"))
        return false;
      this.$http.delete("/api/workstudy/date-schedule/" + id).then((a) => {
        if (a.body.status) {
          alert("刪除成功");
          this.delSchedultReload();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    delScheduleRange(id, scheduleId) {
      if (
        !confirm("您的動作將會刪除此筆與其後續排班資料。\n請問是否確認要刪除？")
      )
        return false;
      this.$http
        .delete("/api/workstudy/schedule-range/" + id + "/" + scheduleId)
        .then((a) => {
          if (a.body.status) {
            alert("刪除成功");
            this.delSchedultReload();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    delSchedultReload() {
      $(".monthly-reload").click();
      setTimeout(() => {
        let link = $("td[dt='" + this.selectDate + "']").find(
          "a[href='#multiple']"
        )[0];
        if (link === undefined) {
          $.magnificPopup.close();
        } else {
          this.loadDelList();
          $(link).click();
        }
      }, 500);
    },
    setCheckValue() {
      if (
        !(
          (this.schedule.startHour < 12 ||
            (this.schedule.startHour == 12 && this.schedule.startMin == 0)) &&
          this.schedule.endHour >= 13
        )
      ) {
        this.schedule.isDeductLunch = false;
      }
      if (
        !(
          (this.schedule.startHour < 17 ||
            (this.schedule.startHour == 17 && this.schedule.startMin == 0)) &&
          this.schedule.endHour >= 18
        )
      ) {
        this.schedule.isDeductDinner = false;
      }
    }
  },
};
</script>

<style>
#calendar .btn-schedule {
  z-index: 999;
}
#multiple > .popup-content > table > tr > td {
  padding: 6px;
}
#multiple > .popup-content > table > tr > td > span.blue{
    padding: 5px;
    background-color: #a5c6e9;
    color: black;
    font-size: 1.2em;
    font-weight: bold;
}
#multiple > .popup-content > table > tr > td > span.red{
   padding: 5px;
    background-color: #e4a1ef;
    color: black;
    font-size: 1.2em;
    font-weight: bold;
}
</style>
